import React from 'react';
import { accent2 } from '../globals/colors';
import { staticUrl } from '../globals/urls';
import styled from 'styled-components';
import { Token } from './Token.style';
import { Svg } from '../Svg';

export var CargoToken = styled(Token).attrs(function () {return {
    children: /*#__PURE__*/React.createElement(Svg, { url: staticUrl('images/cargo.svg') })
  };}).withConfig({ displayName: "CargoToken", componentId: "sc-gm5bgl-0" })(["background:", ";"],
accent2);
//# sourceMappingURL=CargoToken.js.map